import { useContext } from 'react';
import { VehiclesChartsDataContext } from '../contexts/VehiclesChartsDataContext';

export const useVehiclesChartsDataContext = () => {
    return useContext(VehiclesChartsDataContext);
};
